/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 6.1.6
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _defaultButtonTheme,
  _this = this;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import FocusButton from '../FocusButton/FocusButton';
import LayoutX from '../LayoutX/LayoutX';
import styles from './keyboard.scss';
import * as layouts from './layouts';
export var KEYBOARD_LAYOUTS_MAP = {
  "default": 'default',
  search: 'search',
  symbol: 'symbol'
};
export var KEYBOARD_CLASSES_MAP = {
  buttonContainer: 'buttonContainer',
  button: 'button',
  buttonFocused: 'buttonFocused',
  buttonActive: 'buttonActive',
  buttonDoubleSizeContainer: 'buttonDoubleSizeContainer',
  buttonTripleSizeContainer: 'buttonTripleSizeContainer',
  buttonQuadrupleSizeContainer: 'buttonQuadrupleSizeContainer',
  buttonSextupleSizeContainer: 'buttonSextupleSizeContainer',
  layout: 'layout'
};
var defaultPrefix = Date.now().toString(36);
var defaultButtonTheme = (_defaultButtonTheme = {}, _defineProperty(_defaultButtonTheme, KEYBOARD_CLASSES_MAP.buttonContainer, styles.buttonContainer), _defineProperty(_defaultButtonTheme, KEYBOARD_CLASSES_MAP.button, styles.button), _defineProperty(_defaultButtonTheme, KEYBOARD_CLASSES_MAP.buttonFocused, styles.buttonFocused), _defineProperty(_defaultButtonTheme, KEYBOARD_CLASSES_MAP.buttonActive, styles.buttonActive), _defineProperty(_defaultButtonTheme, KEYBOARD_CLASSES_MAP.buttonDoubleSizeContainer, styles.buttonDoubleSizeContainer), _defineProperty(_defaultButtonTheme, KEYBOARD_CLASSES_MAP.buttonTripleSizeContainer, styles.buttonTripleSizeContainer), _defineProperty(_defaultButtonTheme, KEYBOARD_CLASSES_MAP.buttonQuadrupleSizeContainer, styles.buttonQuadrupleSizeContainer), _defineProperty(_defaultButtonTheme, KEYBOARD_CLASSES_MAP.buttonSextupleSizeContainer, styles.buttonSextupleSizeContainer), _defineProperty(_defaultButtonTheme, KEYBOARD_CLASSES_MAP.layout, styles.layout), _defaultButtonTheme);
var FocusKeyboard = function FocusKeyboard(_ref) {
  var col = _ref.col,
    layout = _ref.layout,
    layoutType = _ref.layoutType,
    locale = _ref.locale,
    nav = _ref.nav,
    onVirtualKeyClick = _ref.onVirtualKeyClick,
    theme = _ref.theme,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? defaultPrefix : _ref$prefix;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    layoutMap = _useState2[0],
    setLayoutMap = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    themeOverride = _useState4[0],
    setThemeOverride = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    navOverride = _useState6[0],
    setNavOverride = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    uppercase = _useState8[0],
    setUppercaseState = _useState8[1];
  var localLayout = useMemo(function () {
    if (layout) {
      return layout;
    }
    var resolvedExportedLayout = layouts[locale][layoutType] || layouts.en[layoutType] || layouts[locale]["default"];
    var resolvedLayout = {};

    // Those are required to be able to re-assign the value later for upper/lower casing
    resolvedLayout.textArray = Object.assign(resolvedExportedLayout.textArray);
    resolvedLayout.FEATURE_KEY = Object.assign(resolvedExportedLayout.FEATURE_KEY);
    var featuredKeysText = Object.values(resolvedLayout.FEATURE_KEY).map(function (featureKey) {
      return featureKey.text;
    });
    if (uppercase) {
      resolvedLayout.textArray = resolvedLayout.textArray.map(function (item) {
        if (!featuredKeysText.includes(item)) {
          return item.toUpperCase();
        }
        return item;
      });
    } else {
      resolvedLayout.textArray = resolvedLayout.textArray.map(function (item) {
        if (!featuredKeysText.includes(item)) {
          return item.toLowerCase();
        }
        return item;
      });
    }
    return resolvedLayout;
  }, [layout, layouts, locale, layoutType, uppercase]);
  var getMatchedFeature = useCallback(function (text) {
    var matchedFeature = Object.entries(localLayout.FEATURE_KEY).find(function (obj) {
      return text === obj[1].text;
    });
    return (matchedFeature === null || matchedFeature === void 0 ? void 0 : matchedFeature[1]) || {};
  }, [localLayout]);
  var switchUppercase = function switchUppercase() {
    return setUppercaseState(!uppercase);
  };
  var handleVirtualKeyClick = function handleVirtualKeyClick(text) {
    var matchedFeature = getMatchedFeature(text);
    if (matchedFeature !== null && matchedFeature !== void 0 && matchedFeature.func) {
      matchedFeature === null || matchedFeature === void 0 ? void 0 : matchedFeature.func(text, switchUppercase); // We pass the switchUppercase everywhere just in case
    } else {
      onVirtualKeyClick === null || onVirtualKeyClick === void 0 ? void 0 : onVirtualKeyClick(text, matchedFeature);
    }
  };
  var updateLayoutMap = useCallback(function () {
    var layoutMapLocal = layoutMap;
    if (!layoutMapLocal) {
      layoutMapLocal = '';
      var spaceCount = 0;
      for (var i = 0, l = localLayout.textArray.length; i < l; i += 1) {
        var matchedFeature = getMatchedFeature(localLayout.textArray[i]);
        var elementColumns = matchedFeature ? matchedFeature.columns || 1 : 1;
        for (var j = 0; j < elementColumns; j += 1) {
          layoutMapLocal += "".concat(prefix + i, "  ");
          spaceCount += 1;
        }
        if (spaceCount === col) {
          layoutMapLocal += '\n';
          spaceCount = 0;
        }
      }
    }
    setLayoutMap(layoutMapLocal);
  }, [col, setLayoutMap, getMatchedFeature, localLayout, layoutMap, prefix]);
  useEffect(function () {
    updateLayoutMap();
    setThemeOverride(_objectSpread(_objectSpread({}, defaultButtonTheme), theme));
    setNavOverride(_objectSpread(_objectSpread({}, nav), {}, {
      forwardFocus: ''.concat(prefix, '0')
    }));
  }, [nav, theme, updateLayoutMap, prefix]);
  var renderKey = function renderKey(text, index) {
    var matchedFeature = getMatchedFeature(text);
    var buttonContainerTheme = matchedFeature && matchedFeature.themeClass ? themeOverride[matchedFeature.themeClass] : themeOverride.buttonContainer;
    var toDisplay = matchedFeature && matchedFeature.component ? matchedFeature.component : text;
    return /*#__PURE__*/React.createElement(FocusButton, {
      key: text,
      nav: {
        id: ''.concat(prefix).concat(index),
        parent: nav.id
      },
      onClick: handleVirtualKeyClick.bind(_this, text),
      theme: {
        buttonContainer: buttonContainerTheme,
        button: themeOverride.button,
        buttonFocused: themeOverride.buttonFocused
      }
    }, toDisplay);
  };
  if (!layoutMap || Object.keys(themeOverride).length === 0 || Object.keys(navOverride).length === 0) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement(LayoutX, {
    className: themeOverride.layout,
    layout: layoutMap,
    nav: navOverride
  }, localLayout.textArray.map(renderKey));
};
FocusKeyboard.defaultProps = {
  col: 10,
  layoutType: 'default',
  locale: 'en'
};
FocusKeyboard.propTypes = {
  /** Number of colums for the layout. Needs to by in sync with layout (Both width and letters) */
  col: PropTypes.number,
  /** Layout to be presented in the keyboard */
  layout: PropTypes.shape({
    FEATURE_KEY: PropTypes.objectOf(PropTypes.shape({
      /** Size in columns for the navigation */
      columns: PropTypes.number,
      /** Custom component to use */
      component: PropTypes.oneOfType([PropTypes.object, PropTypes.elementType]),
      /** Custom function to use when the key is pressed/clicked/actioned */
      func: PropTypes.func,
      /** String to use to match against the textArray item */
      text: PropTypes.string.isRequired,
      /** className string to use from the theme */
      themeClass: PropTypes.string,
      /** value to insert into the associated input or similar */
      value: PropTypes.string.isRequired
    })).isRequired,
    /** Array of all the items in the keyboard layout. Special behaviour (size, component, ...) will be done by using a matching FEATURE_KEY where the text is matching the value in the array */
    textArray: PropTypes.array.isRequired
  }),
  /** Layout type to select from 'default', 'caps', 'symbol' and 'search' */
  layoutType: PropTypes.string,
  /** ISO locale code to select layout when not provided an specific custome layout */
  locale: PropTypes.string,
  /** nav object from @accedo/vdkweb-navigation */
  nav: PropTypes.object,
  /** Function to execute when any virtual key is pressed/clicked/actioned and no specific key func handler is provided */
  onVirtualKeyClick: PropTypes.func,
  /** Prefix to use for nav */
  prefix: PropTypes.string,
  /** Theme object to apply styles (layout, buttonContainer, button, buttonFocused, buttonActive, buttonDoubleSizeContainer, buttonTripleSizeContainer, buttonQuadrupleSizeContainer, buttonSextupleSizeContainer) You can create custom classes to use in your keyboard and use it for specific letter/symbols using the layout.FEATURE_KEY.theme  */
  theme: PropTypes.object
};
export default FocusKeyboard;